document
  .querySelector('meta[name=theme-color]')
  ?.setAttribute('content', document.querySelector('.header-main__top-bar__text span') ? '#ed1c24' : '#fff');
